var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2637 7.73665C22.2637 3.46381 18.7999 0 14.527 0C10.2542 0 6.79039 3.46381 6.79039 7.73665V17.4075C6.79039 21.6803 10.2542 25.1441 14.527 25.1441C18.7999 25.1441 22.2637 21.6803 22.2637 17.4075V7.73665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.987671 17.4082C0.987671 19.1862 1.33787 20.9468 2.01828 22.5894C2.69868 24.232 3.69597 25.7246 4.95319 26.9818C6.21041 28.239 7.70296 29.2363 9.3456 29.9167C10.9882 30.5971 12.7488 30.9473 14.5268 30.9473C16.3048 30.9473 18.0654 30.5971 19.708 29.9167C21.3506 29.2363 22.8432 28.239 24.1004 26.9818C25.3576 25.7246 26.3549 24.232 27.0353 22.5894C27.7157 20.9468 28.0659 19.1862 28.0659 17.4082M14.5268 36.7498V32.8815",
    stroke: "white",
    strokeWidth: 1.97531,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicWhite);
export default __webpack_public_path__ + "static/media/micWhite.3982e32f370a8969500ebf66e78a5eb8.svg";
export { ForwardRef as ReactComponent };